import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
const deleteSupplyFavoritesMutation = gql`mutation delete_supply_favorites($supply_id: uuid, $supply_variant_id: uuid){
  delete_supply_favorites(where:{supply_id: {_eq: $supply_id}, supply_variant_id:{_eq:$supply_variant_id}}){
    affected_rows
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class DeleteSupplyFavoritesService {

  constructor(private apollo: Apollo) { }

  deleteSupplyFavorites(supply_id: string, supply_variant_id: string): Promise<any> {
    return this.apollo.use('external').mutate({
      mutation: deleteSupplyFavoritesMutation,
      variables: {
        supply_id,
        supply_variant_id
      }
    }).toPromise();
  }
}
